import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Image from "@src/components/core-image"
import ResponsiveSection from "@src/components/container-responsive-section"
import { REASONS_TO_BOOK } from "@src/utils/constants/social-proof-reasons-to-book"
import Button from "@src/components/reusable/button"

const SocialProofContainer = styled(ResponsiveSection)`
  background-color: #daece4; // Refactor into theme with design guide update
  padding: 40px 20px;
  justify-items: center;

  .paragraphs {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  @media (max-width: 768px) {
    padding: 30px 0;
  }

  // Font
  & > * {
    font-family: system-ui; // New scheme - Natasha
    letter-spacing: 0.5px; // New scheme - Natasha
    font-size: 1rem;
    line-height: 1.5rem;
    text-align: center;
  }

  & h2,
  & h3 {
    font-family: system-ui; // New scheme - Natasha
    letter-spacing: 0.5px; // New scheme - Natasha
  }

  & h2 {
    color: ${props => props.theme.secondary800};
    text-align: center;
    font-size: 38px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: 0.5px;
    // Required for underline
    line-height: 2.5rem;
    // Underline
    & > span.underline {
      display: inline-block;
      background-image: url(/images/social-proof-underline.svg);
      background-repeat: no-repeat;
      background-position-y: bottom;
      background-position-x: center;
      height: 50px;
    }
  }

  & h3 {
    color: ${props => props.theme.secondary800};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 16px !important;
    margin-top: 16px;
  }
  & > p {
    font-family: Figtree;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: ${props => props.theme.secondary800};
  }
  & > div.reasons-container {
    flex-wrap: wrap;

    padding: 30px 0;
    & > div.reason {
      width: 30%;

      @media (max-width: 768px) {
        width: 100%;
      }

      :not(:last-child) {
        margin-bottom: 40px;
      }
      // Image Sizes
      & > div.lazyload-wrapper {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        & > img {
          height: 85px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .reasons-container {
      gap: 20px;
      display: flex;
      flex-direction: column;
    }
    & > div.actions {
      display: flex;
      flex-direction: column;
    }
  }

  @media only screen and (${props => props.theme.screen.small.min}) {
    & > div.reasons-container {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      gap: 32px;
      & > div.reason {
        display: flex;
        flex-direction: column;
        flex-basis: calc(50% - 40px);
        /* width: 100%; */
        justify-content: center;
        // Remove 40px margin from vertical layout
        :not(:last-child) {
          margin-bottom: 0px;
        }
        // Required to maintain bottom alignment between images
        & > .paragraphs {
          height: 102px;
        }
      }
    }
  }
  @media only screen and (${props => props.theme.screen.medium.min}) {
    & > div.reasons-container {
      /* flex-wrap: nowrap; */
      & > div.reason {
        flex-basis: unset;
        /* width: 100%; */

        // Required to maintain bottom alignment between images
        & > .paragraphs {
          min-height: 110px;
        }
      }
    }
  }
`

const SocialProofReasonsV2 = ({ groupType, tourType }) => {
  // Find a matching item based on groupType and tourType
  const matchingReason = REASONS_TO_BOOK.find(
    item => item.tourType === tourType && item.groupType === groupType,
  )

  // Always include the last two items
  const lastTwo = REASONS_TO_BOOK.slice(-2)

  // If there's a match, show it + last two
  // Otherwise, show the first item + last two
  const selectedReasons = matchingReason
    ? [matchingReason, ...lastTwo]
    : [REASONS_TO_BOOK[0], ...lastTwo]

  return (
    <SocialProofContainer>
      <h2>
        Why <span className="underline">book</span> with 10 Adventures?
      </h2>
      <div className="reasons-container">
        {selectedReasons.map(reason => (
          <div className="reason" key={reason.title}>
            <Image src={reason.image} alt={`${reason.title} Image`} />
            <h3>{reason.title}</h3>
            <p>{reason.details}</p>
          </div>
        ))}
      </div>
      <p>{`Let's start talking about your next adventure!`}</p>
      <div className="actions">
        <Button type="greenShade" to="/contact/">
          Contact us
        </Button>
        <Button type="outlineQuestion" to="/ten-reasons-why/">
          10 reasons to book with us
        </Button>
      </div>
    </SocialProofContainer>
  )
}
SocialProofReasonsV2.propTypes = {
  className: PropTypes.string,
}
export default SocialProofReasonsV2
